import { RoomProvider } from '@liveblocks/react'
import { PropsWithChildren, type ReactNode } from 'react'

import { useGetRoomByAssessmentId } from '@/api/assessments.hook'

import { Loading } from '@/components/lemmala-design-system/loading/loading'

import { CommentsLoadError } from './comments-load-error'

type AssessmentRoomProviderProps = {
  assessmentId: string
  // Surfaces in narrow containers pass their own placeholder; the default suits a page body.
  fallback?: ReactNode
} & PropsWithChildren

// Every comment surface of an assessment — the page-level panel and each control drawer —
// shares one room. The Liveblocks client itself is mounted higher up by TenantCommentsProvider.
export const AssessmentRoomProvider = ({
  assessmentId,
  fallback,
  children,
}: AssessmentRoomProviderProps) => {
  const { roomId, error } = useGetRoomByAssessmentId(assessmentId)

  if (error) return <CommentsLoadError />

  if (!roomId) return <>{fallback ?? <Loading />}</>

  return (
    <RoomProvider id={roomId} initialPresence={{}}>
      {children}
    </RoomProvider>
  )
}
